import React from 'react';

// Components
import HistoricalScenariosFilterItemActions from './components/HistoricalScenariosFilterItemActions';
import { Checkbox } from '@/views/components/inputs';
import { HoldingIcon } from '@/views/components/common';

// Libraries
import classNames from 'classnames';
import { VALUE_ENTER } from 'keycode-js';

// Types
import DropdownItem from '@/types/dropdown-item';
import { UUID } from '@/types/global';

interface HistoricalScenariosFilterDropdownItemsProps {
  items: DropdownItem[];
  readOnly?: boolean;
  onDeleteScenario: (id: UUID) => void;
  onDropdownItemClick: (item: DropdownItem) => void;
  onEditScenario: (id: UUID) => void;
  onToggleItem: (item: DropdownItem, isToggled?: boolean) => void;
  validateIfItemIsSelected: (item: DropdownItem) => boolean;
}

const HistoricalScenariosFilterDropdownItems: React.FC<HistoricalScenariosFilterDropdownItemsProps> = ({
  items,
  readOnly,
  onDeleteScenario,
  onDropdownItemClick,
  onEditScenario,
  onToggleItem,
  validateIfItemIsSelected,
}) => {
  const handleKeyDown = (item: DropdownItem, e: React.KeyboardEvent) => {
    if (e.key === VALUE_ENTER) {
      e.nativeEvent.stopImmediatePropagation();
      onDropdownItemClick(item);
    }
  };

  const setCheckboxLabel = (item: DropdownItem) => {
    const { type, color, label, value } = item;
    return (
      <>
        {type && color && <HoldingIcon type={type} color={color} />}
        {label || value.toString()}
      </>
    );
  };

  return (
    <ul role="listbox">
      {items.map((item, i) => (
        <li aria-selected={validateIfItemIsSelected(item)} className={classNames({ selected: validateIfItemIsSelected(item) })} key={i} role="option">
          <div className="group-option-checkbox" onKeyDown={event => handleKeyDown(item, event)}>
            <Checkbox
              className={item.className}
              label={setCheckboxLabel(item)}
              onChange={(toggled: boolean) => onToggleItem(item, toggled)}
              selected={validateIfItemIsSelected(item)}
              disabled={readOnly}
            />
          </div>
          {(item.canEdit || item.canDelete) && (
            <HistoricalScenariosFilterItemActions item={item} onDeleteScenario={onDeleteScenario} onEditScenario={onEditScenario} />
          )}
        </li>
      ))}
    </ul>
  );
};

export default HistoricalScenariosFilterDropdownItems;
